import capitalizefirst from './capitalizefirst';
import normalizetext from './normalizetext';
import mobileformat from './mobileformat';

export default [capitalizefirst, normalizetext, mobileformat];
